import { categories } from './categories'
import { countries } from './countries'
import { currencies } from './currencies'
import { emissionItemCategories } from './emissionItemCategories'
import { fuelTypes } from './fuelTypes'
import { ghgCategories } from './ghgCategories'
import { vehicleTypes } from './vehicleTypes'

export const translations = {
	countries,
	currencies,
	fuelTypes,
	vehicleTypes,
	categories,
	emissionItemCategories,
	ghgCategories,
	pagination: {
		previous: 'Forrige',
		next: 'Neste',
	},
	reports: {
		pageTitle: 'Rapporter',
		newReport: 'Opprett ny rapport',
		newReportNoYears: 'Ingen rapporteringsår funnet',
		backToReports: 'Tilbake til rapporter',
		create: 'Opprett',
		noReports: 'Dere har ikke opprettet rapport enda',
		noReportsDescription:
			'Her kan dere lage rapporter over deres klimagassutslipp. De kan enkelt deles med kunder eller andre, og følger selvsagt kravene til et klimaregnskap.',
		noReportsNoYears: 'Det er ikke mulig å lage rapporter enda',
		noReportsDescriptionNoYears:
			'For å opprette rapporter må utslippene godkjennes først. Dette gjør du på siden transaksjoner.',
		goToTransactions: 'Gå til transaksjoner',
		reportInformation: {
			title: 'Rapportinformasjon',
			baseYear: 'Referanseår',
			baseYearReasoning: 'Begrunnelse for referanseår',
			reportingYear: 'Rapporteringsår',
			projects: 'Prosjekter',
			reportTitle: 'Rapportnavn',
			continue: 'Fortsett',
		},
		companyInformation: {
			title: 'Bedriftsinformasjon',
			name: 'Navn',
			organizationNumber: 'Organisasjonsnummer',
			organizationNumberShort: 'Org.nr.',
			address: 'Adresse',
			industry: 'Næring',
			lastSubmittedAnnualReport: 'Siste innsendte årsregnskap',
			registeredInBusinessRegistry: 'Registrert i enhetsregisteret',
			registeredInVATRegistry: 'Registrert i MVA-registeret',
			registeredInEnterpriseRegistry: 'Registrert i Foretaksregisteret',
			purpose: 'Vedtektsfestet formål',
			activity: 'Aktivitet/Bransje',
		},
		table: {
			title: 'Tittel',
			created: 'Opprettet',
			baseYear: 'Referanseår',
			reportingYear: 'Rapporteringsår',
		},
		actions: {
			view: 'Se',
			download: 'Last ned',
			regenerate: 'Regenerer',
			delete: 'Slett',
		},
	},
	responsiveDisclaimer: {
		title: 'Ikke optimalisert for små skjermstørrelser',
		description: 'Løsningen er best egnet for bruk på en større skjerm',
	},
	common: {
		edit: 'Rediger',
		save: 'Lagre',
		reset: 'Tilbakestill',
		submit: 'Send inn',
		submitting: 'Sender inn...',
		cancel: 'Avbryt',
		close: 'Lukk',
		search: 'Søk...',
		loading: 'Laster...',
		backToSafety: 'Gå tilbake til sikkerhet',
		actions: 'Handlinger',
		add: 'Legge til',
		remove: 'Fjerne',
		errors: {
			unknown: 'En feil oppsto. Vennligst prøv igjen.',
			userNotFound: 'Bruker ikke funnet',
			pageNotFound: 'Beklager, siden finnes ikke',
		},
		emissionOriginalValue: 'Original verdi:',
	},
	navbar: {
		activeImport: 'Importerer nye transaksjoner',
		navigation: {
			overview: 'Oversikt',
			accounts: 'Konti',
			emissions: 'Utslipp',
			transactions: 'Transaksjoner',
			dataImport: 'Importer bilag',
			reports: 'Rapporter',
		},
		menu: {
			trigger: 'Konto',
			logout: 'Logg ut',
			profile: 'Profil',
			settings: 'Innstillinger',
			switchTo: 'Bytt til',
			addOrganization: 'Legg til organisasjon',
			knowledgeBase: 'Kunnskapsbase',
		},
	},
	organizations: {
		pageTitle: 'Organisasjoner',
	},
	emissionFactors: {
		pageTitle: 'Utslippsfaktorer',
		newFactor: 'Ny utslippsfaktor',
		newFactorDescription:
			'Opprett en ny utslippsfaktor. Du kan også opprette en oppslagskonfigurasjon for å automatisk matche nye utslippslinjer til denne faktoren.',
		name: 'Navn',
		factor: 'Faktor',
		unit: 'Enhet',
		unit_type: 'Enhetstype',
		region: 'Region',
		year: 'År',
		sector: 'Sektor',
		source: 'Kilde',
		category: 'Kategori',
		activityId: 'Aktivitets-ID',
		description: 'Beskrivelse',
		sourceLink: 'Kilde lenke',
		co2eTotal: 'CO2e Totalt',
		ch4: 'CH4',
		co2: 'CO2',
		n2o: 'N2O',
		co2eOther: 'CO2e Andre',
		sourceLcaActivity: 'Kilde LCA Aktivitet',
		factorCalculationMethod: 'Beregningsmetode',
		factorCalculationOrigin: 'Kilde for beregningsmetode',
		area_unit: 'Område',
		time_unit: 'Tid',
		distance_unit: 'Distanse',
		data_unit: 'Data',
		energy_unit: 'Energi',
		money_unit: 'Valuta',
		volume_unit: 'Volumn',
		weight_unit: 'Vekt',
		unknown: 'Ukjent',
		calculationOriginSource: 'Kilde',
		calculationOriginKlara: 'Klara',
		factorLookupsTitle: 'Oppslagskonfigurasjoner',
		noLookupsFound: 'Ingen oppslagskonfigurasjoner funnet',
		createNewLookup: 'Opprett ny oppslagskonfigurasjon',
		activityIds: 'Aktivitets-IDer',
		activityIdsDescription: 'En liste med aktivitets-IDer, en per linje',
		duplicateLookup:
			'En eksisterende oppslagskonfigurasjon med samme verdier finnes allerede, for en annen utslippsfaktor, trykk på "Erstatt" for å erstatte den eksisterende oppslagskonfigurasjonen',
		replaceDuplicate: 'Erstatt',
		lookupCreated: 'Oppslagskonfigurasjon opprettet',
	},
	activities: {
		pageTitle: 'Aktiviteter',
		search: 'Søk',
		usedBySystem: 'Brukt internt av Klara',
		create: 'Ny aktivitet',
		errors: {
			duplicate: 'En aktivitet med samme verdier finnes allerede',
		},
		confirmDeleteDescription:
			'Er du sikker på at du vil slette denne aktiviteten?',
		label: 'Etikett',
		type: 'Type og variant',
		activityIds: 'Activity IDs',
		description: 'Beskrivelse',
		accountRanges: 'Konti rekkevidder',
		allTypes: 'Alle',
		unitType: 'Enhetstype',
		weight: 'Vekt',
		volume: 'Volum',
		area: 'Areal',
		cost: 'Kostnad',
		distance: 'Avstand',
		time: 'Tid',
		energy: 'Energi',
		suggestedActivities: 'Anbefalt aktiviteter',
		foundActivities:
			'Funnet {count} {count, plural, one {aktivitet} other {aktiviteter}}',
		noActivitiesFound: 'Ingen aktiviteter funnet med valgte søk',
		noActivitiesFoundDescription: 'Prøv en ny søk eller annen sektor',
	},
	accountMapping: {
		pageTitle: 'Konto kartlegging',
		accountRange: 'Kontoområde',
		account: 'Konto',
		description: 'Beskrivelse',
		activity: 'Aktivitet',
		scope: 'GHG Scope',
		category: 'GHG Kategori',
	},
	orgSettings: {
		header: 'Organisasjonsinnstillinger',
		name: 'Navn',
		orgNumber: 'Org Nr.',
		industry: 'Næring',
		sections: {
			integration: 'Integrasjon',
			team: 'Team',
			plan: 'Plan',
			payment: 'Betaling',
		},
		integration: {
			title: 'Integrasjon',
		},
	},
	userSettings: {
		header: 'Brukerinnstillinger',
		userInfo: {
			name: 'Navn:',
			email: 'E-post:',
			phone: 'Mobilnummer:',
		},
		authentication: {
			heading: 'Passkey-nøkler',
			noPasskeys: 'Du har ingen passkey-nøkler',
			addPasskey: 'Opprett nøkkel',
			noSupport: 'Din nettleser støtter ikke passkey',
			passkeysExplanation:
				'Enheten din støtter passkey-nøkler, en passorderstatning som validerer identiteten din ved bruk av berøring, ansiktsgjenkjenning, enhetspassord eller PIN-kode. <br></br> Passkey-nøkler kan brukes for innlogging som et enkelt og sikkert alternativ til passord og to-faktor autentisering.',
			signInWithPasskey: 'Logg inn med passkey-nøkkel',
			confirmDelete: 'Slette passkey-nøkkelen?',
			confirmDeleteDescription: `Er du sikker på at du vil slette "{description}" nøkkelen?<br></br> Om du fjerner denne nøkkelen kan du ikke lenger logge inn med den på noen enheter som har den. <br></br> Husk at du vil kunne fortsette å få denne nøkkelen som forslag til innlogging til du også fjerner den fra nettleseren, enheten eller tjenesten hvor du opprettet den.`,
			delete: 'Slett',
			passkeyDates: 'Opprettet {created} | Sist brukt {lastUsed}',
			editPasskeyTitle: 'Rediger passkey-nøkkel',
			passkeyDescription: 'Beskrivelse',
		},
	},
	users: {
		name: 'Navn',
		email: 'E-post',
		phone: 'Mobilnummer',
		company: 'Bedriftsnavn',
		role: 'Rolle',
		dateAdded: 'Lagt til',
		teamHeader: 'Team',
		invitesHeader: 'Invitasjoner',
		removeUser: 'Fjern bruker',

		userOrganizationRoles: {
			OWNER: 'Eier',
			MEMBER: 'Medlem',
		},
		userOrganizationRoleDescriptions: {
			OWNER: 'Har full tilgang til organisasjonen',
			MEMBER: 'Kan ikke administrere brukere',
		},
		addOrganizationUser: {
			title: 'Legg til teammedlem',
			errors: {
				userAlreadyInvited: 'Bruker er allerede invitert',
			},
			invitationSent: 'Invitasjon sendt',
			resendInvite: 'Send invitasjon på nytt',
			removeInvite: 'Fjern invitasjon',
		},
		removeOrganizationUser: {
			confirm: 'Slette teammedlem?',
			description: 'Du er i ferd med å slette teammedlem <b>{email}.</b>',
			action: 'Slett',
		},
	},
	invite: {
		heading: 'Du har blitt invitert til {organizationName}',
		mustBeCorrectUser:
			'For å godta invitasjonen, må du være logget inn med e-post <b>{email}</b>.',
		canCreateUser:
			'Har du ikke en bruker registrert for denne e-posten? Klikk på "Opprett bruker"',
		alreadyHaveUser:
			'Har du allerede en bruker? Logg inn med e-posten <b>{email}</b>',
		createUserCTA: 'Opprett bruker',
		loginCTA: 'Logg inn',
		acceptInvitation: 'Godta invitasjonen til {organizationName}?',
		decline: 'Avslå',
		accept: 'Godta',
	},
	onboard: {
		steps: {
			0: 'Opprett konto',
			1: 'Betaling',
			2: 'Importere bilag',
		},
		success: {
			title: 'Gratulerer – din konto er nå klar for bruk!',
			subtitle:
				'Du kan nå gå til importsiden for å følge fremgangen og justere importinnstillinger.',
			cta: 'Gå til importsiden',
		},
		product: {
			title: 'Hvordan vil du begynne?',
			subTitle: 'Velg beregningsmetode',
			spend: {
				title: 'Klara Karbon',
				price: 'fra 99 NOK/mon',
				description:
					'Utslippet blir kalkulert ut i fra beløp i SAF-T filen. Last opp SAF-T filen for ønsket periode og få mulighet til å rapportere deres utslipp. Raskt og enkelt!',
			},
			activity: {
				title: 'Klara Karbon AI',
				price: 'fra 249 NOK/mon',
				description:
					'Utslippet blir kalkulert ut fra aktiviteter i bilagene i regnskapet deres. Opprett integrasjon til deres regnskapssystem for å arbeide mer med deres utslipp. Her er klimaregnskapet like oppdatert som regnskapet deres!',
				demoPrompt: 'Prøv Klara KI uten å koble til regnskapssystemet?',
				demoAction: 'Start med testdata',
			},
		},
		org: {
			connect: {
				title: 'Opprett konto for {companyName}',
				createAccount: 'Opprett konto',
				explanation:
					'Vi må opprette en konto for organisasjonen din. Dette vil gjøre det mulig for oss å importere relevante dokumenter fra regnskapssystemet ditt og beregne dine klimagassutslipp.',
				errors: {
					generic: 'Det oppsto en feil under opprettelsen av kontoen',
					organizationMissingName: 'Organisasjonen mangler navn',
					organizationAlreadyAdded: 'Organisasjonen er allerede lagt til',
					noVouchers: 'Filen inneholder ingen bilag',
				},
				acceptDpa: {
					textStart: 'Jeg har lest og godtar',
					linkText: 'Databehandleravtalen',
					error: 'Du må akseptere vår databehandleravtalen',
				},
				acceptEula: {
					textStart: 'Jeg godtar',
					linkText: 'Lisensavtalen',
					textEnd:
						'for sluttbrukere (EULA) som regulerer bruken av denne programvaren.',
					error: 'Du må akseptere vår lisensavtalen',
				},
				dataSources: {
					tripletex: {
						explanationManual:
							'Vi trenger tilgang til deres Tripletex-konto for å importere relevante bilag, slik vi kan beregne deres utslipp av klimagasser.',
						tripletexToken: 'Tripletex nøkkel',
						howToFindToken: {
							textStart: 'Hvordan finner jeg',
							linkText: 'Tripletex API brukernøkkelen',
						},
						employeeApiToken: 'Tripletex API brukernøkkel',
						updateIntegration: {
							title: 'Oppdater integrasjon',
							description: 'Dette vil oppdatere tilkoblingen for',
							action: 'Oppdater',
							success: 'Integrasjonen er oppdatert',
						},
					},
					powerOfficeGo: {
						clientKey: 'PowerOffice Go klientnøkkel',
						createPowerOfficeGoIntegration:
							'Opprette PowerOffice Go integrasjon',
						explanation:
							'<p>Følg lenken nedenfor for å koble til Power Office.</p><p>Merk! Legg kun til én klient om gangen.</p>',
						connect: 'Koble til PowerOffice Go',
						connectAgain: 'Tilbake til PowerOffice Go',
						connectErrors: {
							authorizationUnsuccessful: {
								title: 'Autorisasjonen var ikke vellykket',
								explanation:
									'Klikk på knappen nedenfor for å gå tilbake til Power Office Go',
							},
							noClient: {
								title: 'Ingen klient ble valgt',
								explanation:
									'Klikk på knappen nedenfor for å gå tilbake til Power Office Go og velg en klient',
							},
							multipleClients: {
								title: 'Kun én klient kan legges til om gangen',
								explanation:
									'Klikk på knappen nedenfor for å gå tilbake til Power Office Go og velg én klient',
							},
							generic: {
								title:
									'En feil oppstod under opprettelsen av PowerOffice Go integrasjonen',
								explanation:
									'Klikk på knappen nedenfor for å gå tilbake til Power Office Go',
							},
						},
						manualKeyEntry: {
							text: 'Har du allerede aktivert integrasjonen i <b>PowerOffice Go</b> og har mottatt en klientnøkkel?',
							linkText: 'Bruk dette skjemaet i stedet',
						},
					},
					twentyFourSevenOffice: {
						explanationManual:
							'Vi trenger tilgang til deres 24SevenOffice-konto for å importere relevante bilag, slik vi kan beregne deres utslipp av klimagasser. <br></br> <a>Følg denne guiden for å finne klient-IDen din.</a>',
						clientId: {
							label: '24SevenOffice klient Id',
							placeholder: 'Skriv inn klient Id',
						},
					},
				},
			},
			payment: {
				accountCreated: 'Konto er opprettet',
				heading: 'Betalingsinformasjon',
				countryWarning: {
					title: 'Kun regnskapsinformasjon fra Norge støttes',
					description:
						'Filen du har lastet opp er fra et annet land, og støttes for øyeblikket av Klara Karbon.',
				},
				products: {
					basicSubscription: 'Klara Basic',
					analyzedTransactions: 'Import av bilag',
					monthly: 'kr/måned',
					perDocument: 'kr per bilag',
					couponValidUntil: 'Tilbudet gjelder frem til {date}',
				},
				form: {
					contactName: 'Kontaktperson',
					contactEmail: 'Kontakt e-post',
					companyName: 'Firmanavn',
					organizationNumber: 'Organisasjonsnummer',
					address: 'Adresse',
					postalCode: 'Postnummer',
					postalArea: 'Poststed',
					submit: 'Godkjenn betalingsvilkår',
					description:
						'Når du godkjenner <a>betalingsvilkårene</a>, vil virksomheten faktureres. Fakturaen sendes til kontaktpersonens e-postadresse.',
				},
			},
			import: {
				paymentAdded: 'Betalingsinfo er lagret',
				title: 'Importere bilag',
				explanation:
					'Vi skal nå gjennomgå og telle deres bilag. Velg en periode nedenfor.',
				from: {
					label: 'Fra',
					placeholder: 'Velg år',
				},
				to: {
					label: 'Til',
				},
				importLimit: {
					label: 'Din importgrense',
					perMonth: 'i måneden',
					description:
						'Klara varsler deg når en import overskrider din månedlige grense. Du kan endre grensen her eller under organisasjonsinnstillinger.',
				},
				startReview: 'Start gjennomgang',
			},
			importInProgress: {
				title: 'Importerer transaksjoner..',
				emailUponCompletion:
					'Du vil motta en e-post fra oss når importen er fullført.',
				useWhileImporting:
					'I mellomtiden er du velkommen til å begynne å bruke Klara. Vær oppmerksom på at transaksjoner fortsatt kan være i ferd med å bli importert.',
				startUsing: 'Ta i bruk Klara',
			},
			approval: {
				title: 'Avventer kontogodkjenning',
				explanation:
					'I beta-perioden, må alle nye kontoer manuelt godkjennes av oss.',
				emailUponApproval: 'Du mottar en e-post når kontoen din er godkjent.',
			},
		},
	},
	overview: {
		title: 'Oversikt over utslipp',
		totalEmissionsTitle: 'Totalt utslipp',
		emissionPerEmployeeTitle: 'Utslipp / ansatt',
		emissionGraphTitle: 'Utslipp',
		spendatureGraphTitle: 'Utgifter',
		spendatureGraphUnit: 'NOK',
		scopes: {
			title: 'Utslipp etter scope',
			descriptions: {
				scope1: 'Direkte utslipp fra kilder du kontrollerer',
				scope2: 'Indirekte utslipp fra elektrisitet, varme og kjøling',
				scope3: 'Andre indirekte utslipp',
			},
			scopeCard: {
				categoryHeader: 'GHG-kategori',
				emissions: 'Utslipp ({unit})',
			},
		},
		pendingTransactionsAlert: {
			title: `Du har {count} {count, plural,
				one {transaksjon}
				other {transaksjoner}
			} som venter på deg`,
			description:
				'Gå til transaksjoner for å se og behandle transaksjonene slik at du kan få oppdatert din utslippsberegning',
			cta: 'Se transaksjoner',
		},
	},
	forms: {
		fieldIsRequired: '{field} er påkrevd',
		fieldIsInvalid: '{field} er ugyldig',
		selectField: 'Velg {field}',
		retry: 'Prøv igjen',
		supportedFormats: 'Kun {supportedFormats} filer støttes',
		uploadSaft: 'Last opp SAF-T',
		uploadError: 'Kunne ikke behandle filen: {message}',
		supportedFileTypes: 'Støttede filtyper: {supported}',
	},
	transactions: {
		emptyMessages: {
			pending: {
				title:
					'Flott! Alle transaksjonene som matcher valgte filtre er nå godkjent.',
				description:
					'Du kan se utslippene i Oversikten eller under Utslipp. Når Klara importerer nye bilag fra regnskapssystemet, vil de automatisk dukke opp her igjen.',
			},
			approved: {
				title: 'Ingen godkjente transaksjoner',
				description: 'Velg "Avventer" for å se og godkjenne transaksjoner',
			},
			discarded: {
				title: 'Ingen avvist transaksjoner',
				description:
					'Alle avviste transaksjoner vil automatisk dukke opp her igjen. Gå til "Avventer" for å se og godkjenne transaksjoner',
			},
		},
		goToPending: 'Gå til Avventer',
		preview: {
			button: 'Forhåndsvis resultater',
			noData: 'Ingen data for forhåndsvisning',
			header: 'Forhåndsvisning:',
			topEmitting: 'Høyeste utslipp',
		},
		bulkApprove: {
			alertTitle: `Dette vil godkjenne {countToApprove} {countToApprove, plural,
				=0 {dokumenter}
				one {dokument}
				other {dokumenter}
		}`,
			description:
				'Alle dokumenter med feil vil fortsatt behøve manuell behandling',
			confirm: 'Godkjenn alle',
			confirmSelected: 'Godkjenn valgte',
			confirmed: 'Godkjent!',
			onlyErrorsLeft: `<p>Du kan ikke godkjenne gjenværende dokumenter.</p>
			<p>Rett opp i gjenværende feil før du kan godkjenne.</p>`,
		},
		bulkSetReviewStatus: {
			alert: {
				title: `Dette vil {action} {countToSet} {countToSet, plural,
        =0 {dokumenter}
        one {dokument}
        other {dokumenter}
      }`,
				actions: {
					approved: 'godkjenne',
					discarded: 'ignorere',
					pending: 'gjenåpne',
				},
			},
			description:
				'Alle dokumenter med feil vil fortsatt behøve manuell behandling',
			confirm: {
				approved: 'Godkjenn valgte',
				discarded: 'Ignorer valgte',
				pending: 'Gjenåpne valgte',
			},
			confirmed: {
				approved: 'Godkjent!',
				discarded: 'Ignorert!',
				pending: 'Gjenåpnet!',
			},
			onlyErrorsLeft: `<p>Du kan ikke sette status på gjenværende dokumenter.</p>
      <p>Rett opp i gjenværende feil før du kan sette status.</p>`,
		},
		listHeader: {
			ledger: 'BILAG',
			items: 'ANTALL',
			ledgerNumber: 'BILAGSNR',
			ghg_scope: 'GHG SCOPE',
			status: 'STATUS',
			ledgerDate: 'BILAGSDATO',
			amount: 'BELØP',
			emission: 'UTSLIPP ({unit})',
		},
		fixErroredItem:
			'Klikk her for å korrigere feil for å fortsette beregningen',
		filters: {
			title: 'Filtere:',
			status: 'Status',
			category: 'Kategori',
			sender: 'Leverandør',
			project: 'Prosjekt',
			dates: {
				none: 'Alle',
				last30d: 'Siste 30 dager',
				lastMonth: 'Forrige måned',
				lastYear: 'Forrige år',
				last6m: 'Forrige halvår',
				thisYear: 'Dette året',
				q1: '1. kvartal',
				q2: '2. kvartal',
				q3: '3. kvartal',
				q4: '4. kvartal',
			},
			clear: 'Nullstill filtere',
			display: {
				range: 'Fra {from} til {to}',
				sender: 'Leverandør: {sender}',
				project: 'Prosjekt: {project}',
				page: 'Side {page}',
			},
		},
		items: {
			titleFallback: 'Ukjent avsender',
			descriptionFallback: 'Beskrivelse mangler',
		},
		transactionListStatus: {
			approved: 'Godkjent',
			pending: 'Avventer',
			discarded: 'Ignorert',
			error: 'Feil',
		},
		details: {
			alert: {
				extraction_yields_no_items: {
					title: 'Ingen utslippslinjer funnet',
					description:
						'Du kan legge til utslippslinjer manuelt eller godkjenne/ignorere det som det er',
				},
			},
			actions: {
				back: 'Tilbake',
				backToAll: 'Tilbake til alle',
				resetToDefault: 'Tilbakestill',
				discard: 'Marker som ignorert',
				approve: 'Godkjenn',
				returnToPending: 'Gjenåpne',
			},
			header: {
				unknownSender: 'Ukjent avsender',
				ledgerNumber: 'Bilagsnummer',
				ledgerDate: 'Bilagsdato',
				status: 'Status',
			},
			edit: {
				sender: {
					header: 'Rediger tittel',
					label: 'Tittel',
				},
				description: {
					header: 'Rediger beskrivelse',
					label: 'Beskrivelse',
				},
			},
			items: {
				header: 'Utslippslinjer',
				addEmission: {
					callToAction: 'Nytt utslipp',
					title: {
						label: 'Utslippstittel',
						placeholder: 'Skriv inn en utslippstittel',
					},
					emissionDate: 'Utslippsdato',
					ghgCategories: {
						label: 'GHG-kategori',
						placeholder: 'Velg GHG-kategori',
					},
					emissionCalculation: 'Utslippsberegning',
					labels: {
						search: 'Søk',
						chooseFromTemplate: 'Velg fra mal',
						orAddYourOwn: 'Eller legg til din egen',
						selectedEmissionFactor:
							'Legg til dine egne utslipp ved å velge utslippsfaktor fra vårt bibliotek',
						specifiedEmissions: 'Legg til en utslippsverdi',
					},
				},
				total: 'Total ({unit})',
				emission: 'Utslipp',
				removeEmissionItem: {
					confirm: 'Slett utslippslinjen?',
					description: `Du er i ferd med å slette varen <b>{itemDescription}.</b>
					<br></br>
					Mengden utslipp fra denne linjen vil bli fjernet fra utslippsberegningen.`,
					action: 'Slett',
				},
				restoreEmissionItem: {
					confirm: 'Gjenopprett utslippslinjen?',
					description: `Du er i ferd med å gjenopprette varen <b>{itemDescription}.</b>
					<br></br>
					Mengden utslipp fra denne linjen vil bli lagt til i utslippsberegningen.`,
					action: 'Gjenopprett',
				},
				emissionItemCalculation: {
					title: 'Utregning, og informasjon om utslippsfaktor',
					calculation: {
						title: 'Utregning',
						formula: 'Formel = Utslippsfaktor x mengde',
						emissionFactor: 'Utslippsfaktor',
						quantity: 'Mengde',
						convertedFrom: 'konvertert fra',
						total: 'Total',
					},
				},
				emissionEstimationError: 'Feil ved beregning av utslipp',
				form: {
					revert: 'Tilbakestill',
					delete: 'Slett',
					viewCalculation: 'Vis beregning',
					toOtherSpendingForm: {
						text: 'Vet du bare beløpet?',
						linkText: 'Bytt til kostnadsbasert',
					},
					backToStandardForm: 'Bytt til aktivitetsbasert',
					description: {
						placeholder: 'Klikk for å redigere tittel',
					},
					optional: 'valgfritt',
					date: {
						label: 'Dato',
					},
					amount: {
						label: 'Beløp (ex. MVA)',
						placeholder: 'Skriv inn beløp (ex. MVA)',
					},
					currency: {
						label: 'Valuta',
						placeholder: 'Velg valuta',
					},
					category: {
						label: 'Kategori',
						placeholder: 'Velg kategori',
					},
					country: {
						label: 'Land',
						placeholder: 'Velg land',
					},
					fuelType: {
						label: 'Drivstofftype',
						placeholder: 'Velg drivstofftype',
					},
					units: {
						energy: {
							label: 'Energi',
							placeholder: 'Skriv inn energi',
						},
						liters: {
							label: 'Liter',
							placeholder: 'Skriv inn liter',
						},
						weight: 'Vekt',
					},
					dateFrom: {
						label: 'Fra',
					},
					dateTo: {
						label: 'Til',
					},
					travelDate: {
						label: 'Reisedato',
					},
					vehicleType: {
						label: 'Type',
						placeholder: 'Velg kjøretøytype',
					},
					distanceCalculation: 'Avstandsberegning',
					travelFrom: {
						label: 'Reise fra',
						placeholder: 'Oppgi opprinnelse',
					},
					travelTo: {
						label: 'Reise til',
						placeholder: 'Oppgi destinasjon',
					},
					totalDistance: {
						label: 'Total avstand',
						placeholder: 'Oppgi total avstand',
					},
					passengers: {
						label: 'Passasjerer',
						placeholder: 'Oppgi antall passasjerer',
					},
					roomNights: {
						label: 'Romnetter',
						placeholder: 'Skriv inn antall romnetter',
					},
					ghgClassification: {
						label: 'GHG Klassifisering',
						placeholder: 'Velg GHG Klassifisering',
						itemLabel: 'Scope {scope} {category}',
					},
					quantity: {
						label: 'Mengde',
						placeholder: 'Skriv inn mengde',
					},
					roadElectric: {
						label: 'Elektrisk',
						description: 'Aktiver hvis kjøretøyet er elektrisk',
					},
					specifiedEmission: {
						emissionValue: {
							label: 'Utslippsverdi',
							placeholder: 'Skriv inn utslippsverdi',
						},
						note: {
							label: 'Merknad',
							placeholder:
								'Beskriv kilden til denne informasjonen eller hvordan du beregnet den. Du kan også nevne din egendefinerte utslippsfaktor her.',
						},
						biological: {
							label: 'Biologisk',
							description:
								'Aktiver hvis utslippet er av biologisk opphav, eksempelvis biodrivstoff, biogasser og tre/ved',
						},
					},
					guaranteeOfOrigin: {
						label: 'Opprinnelsesgaranti',
						description:
							'Om det er en opprinnelsesgaranti, vil det regnes som 0 i markedsbasert utslipp',
					},
					emissionFactor: {
						header: 'Velg utslippsfaktor fra vår bibliotek',
						change: 'Endre',
						resultsFound:
							'{results, plural, =0 {resultater} one {resultat} other {resultater}} funnet',
						apply: 'Bruk',
						filter: 'Filter',
						title: 'Utslipp faktorer',
						sector: 'Sektor',
						placeholderSector: 'Velg sektor',
						category: 'Kategori',
						categoryPlaceholder: 'Velg kategori',
						region: 'Region',
						regionPlaceholder: 'Velg region',
						unit: 'Enhet',
						unitPlaceholder: 'Velg enhet',
					},
					scope: {
						title: 'Scope',
						placeholder: 'Velg scope',
						change: 'Endre',
						value: 'Scope {scope}',
					},
				},
				emissionFactor: {
					ef: 'Utslippsfaktor',
					aboutEf: 'Om utslippsfaktoren',
					labels: {
						name: 'Navn',
						source: 'Kilde',
						year: 'År',
						region: 'Region',
						sector: 'Sektor',
						category: 'Kategori',
						unit_type: 'Enhetstype (S)',
					},
				},
			},
		},
	},
	accounts: {
		listHeader: {
			account: 'Konto',
			description: 'Beskrivelse',
			ghgScope: 'GHG Scope',
			factor: 'Utslippsfaktor',
			amount: 'Beløp ({unit})',
			emission: 'Utslipp ({unit})',
			action: 'Handling',
		},
		items: {
			scope: 'Scope {scope}',
		},
		noAccounts: 'Ingen kontoer som matcher valgte filtre',
		noAccountsDescription:
			'Gå til importsiden for å opprette import eller sjekk status på pågående',
		goToImports: 'Gå til importsiden',
	},
	scope: 'Scope {scope}',
	draft: 'Utkast',
	emissions: {
		filter: {
			scope: {
				all: 'Alle',
			},
		},
		graph: {
			header: {
				scope: 'Scope {scope}',
				allScopes: 'Scope 1, 2, og 3',
			},
		},
		tableHeader: {
			emissionItem: 'Utslipp',
			ledger: 'Hovedbok',
			ledgerNumber: 'Bilagsnummer',
			emissionDate: 'Utslipsdato',
			emission: 'Utslipp',
		},
		table: {
			noEmissions: 'Ingen utslipp funnet',
		},
	},
	login: {
		title: 'Logg inn',
		email: 'E-post',
		submit: 'Logg inn',
		resend: 'Send e-post på nytt',
		createAccount: 'Har du ikke en konto?',
		cta: 'Opprett en nå',
		emailCheck: 'Sjekk din epost',
		emailCheckDescription:
			'Vi har sendt deg en epost til <b>{email}</b> med en lenke for å logge inn. Du kan lukke dette vinduet.',
		webauthn: {
			login: 'Logg inn',
			create: 'Opprett ny nøkkel',
			description: 'Beskrivelse',
			exampleDescription: 'Jobb PC',
		},
	},
	register: {
		title: 'Registrer deg',
		acceptTerms:
			'Jeg samtykker til innsamling og bruk av mine data som beskrevet i',
		privacyPolicy: 'Personvernerklæringen',
		acceptTermsError: 'Du må akseptere vår Personvernerklæring',
		haveAccount: 'Har du allerede en konto?',
		signIn: 'Logg inn',
		submit: 'Registrer deg',
		resend: 'Send e-post på nytt',
		emailCheck: 'Sjekk din epost',
		emailCheckDescription:
			'Vi har sendt deg en epost til <b>{email}</b> med en lenke som du kan bruke for å sette opp din organisasjon. Du kan nå lukke dette vinduet.',
	},
	export: {
		download: 'Eksport',
		ledgerNumber: 'Bilagsnummer',
		ledgerDate: 'Bilagsdato',
		invoiceNumber: 'Faktura ID',
		sender: 'Leverandør',
		account: 'Konti',
		description: 'Beskrivelse',
		emissionDate: 'Utslippsdato',
		ghgScope: 'GHG Scope',
		ghgScopeCategory: 'GHG Kategori',
		ghgScopeSubcategory: 'GHG Subkategori',
		co2e: 'CO2e (kg)',
		co2: 'CO2 (kg)',
		ch4: 'CH4 (kg)',
		n2o: 'N2O (kg)',
		factor: 'Utslippsfaktor',
		factorUnit: 'Enhet',
		quantity: 'Mengde',
		activityQuantity: 'Aktivitetsmengde',
		activityUnit: 'Aktivitetsenhet',
		factorLink: "Utslippsfaktor's link",
		factorName: "Utslippsfaktor's navn",
		factorSource: "Utslippsfaktor's kilde",
		factorYear: "Utslippsfaktor's år",
		factorRegion: "Utslippsfaktor's sektor",
		factorCategory: "Utslippsfaktor's kategori",
		projectId: 'Prosjekt ID',
		projectName: 'Prosjektnavn',
		projectNumber: 'Prosjektnummer',
		projectStartDate: 'Prosjekt startdato',
		projectEndDate: 'Prosjekt sluttdato',
		projectParentId: 'Prosjekt ID forelder',
	},
	requestAnalysis: {
		dialogTitle: 'Antall bilag overstiger din grense',
		importedThisMonth: 'Importert denne måneden',
		numberInImport: 'Avventer import',
		monthlyLimit: 'Månedlig grense',
		description:
			'Hvis du trykker “Godkjenn” vil din grense økes til <b>{limit}</b> + <b>{count}</b> i denne måned. Du kan når som helst endre din måndelig grense under “Innstillinger”.',
		confirm: 'Godkjenn',
	},
	dataImport: {
		heading: 'Dataimport',
		description:
			'Klara importerer kun bilag relevante for karbonregnskap, <b>postert</b> og <b>godkjent</b> i regnskapssystemet.',
		settings: {
			title: 'Innstillinger',
			limitExcemptionSet:
				'Du har satt en unntaksgrense på {limit} denne måneden',
			futureImports: 'Importer fremtidige transaksjoner fortløpende',
			confirmLimitBreach:
				'Be meg bekrefte, dersom antall transaksjoner i løpet av en måned overstiger',
		},
		totalVouchers: 'Bilag importert av Klara så langt',
		ongoingImport: {
			headingImporting: 'Forbereder bilag',
			headingAnalyzing: 'Importerer bilag',
			status: '{analyzed} av {total}',
			mightTakeSomeTime:
				'Dette kan ta litt tid. Du vil motta en e-post når vi er ferdig.',
		},
		import: 'Importer bilag',
		startImport: 'Start import',
		goToTransactions: 'Gå til transaksjoner',
		goToOverview: 'Gå til oversikt',
		fileWarnings: {
			differentOrgNumber: 'Filen inneholder et annet organisasjonsnummer',
			differentCountry: 'Filen inneholder et annet land',
			noVouchers: 'Filen inneholder ingen bilag',
			noValidDateRange: 'Filen inneholder ikke et gyldig datointervall',
			overlappingImports: 'Filen inneholder data som allerede er importert',
		},
	},
}
